import { Flex } from "@itandi/itandi-bb-ui/Flex";
import { Label } from "@itandi/itandi-bb-ui/Label";
import { Td } from "@itandi/itandi-bb-ui/Td";
import { StatusIcon } from "~/components/deprecated/StatusIcon";
import type { ConstructionEndDateStatus } from "~/models/Deal";
import { formatMonthAndDay } from "~/utils/DateUtil";

type Props = {
	constructionEndDate: string | null;
	constructionEndDateStatus: ConstructionEndDateStatus;
};

export function ConstructionEndDateCell({
	constructionEndDate,
	constructionEndDateStatus
}: Props) {
	return (
		<Td verticalAlign="Top">
			{constructionEndDateStatus === "none" ? (
				<Label size="s">施工なし</Label>
			) : constructionEndDateStatus === "scheduled" && constructionEndDate ? (
				<Label size="s">{formatMonthAndDay(constructionEndDate) ?? ""}</Label>
			) : (
				<Flex>
					<Label size="s">未定</Label>
					<StatusIcon variant="Alert" />
				</Flex>
			)}
		</Td>
	);
}
